import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export const Envelope = (props) => (
    <SvgIcon {...props}>
        <path d="M27 26H5c-1.7 0-3-1.3-3-3V9c0-1.7 1.3-3 3-3h22c1.7 0 3 1.3 3 3v14c0 1.7-1.3 3-3 3zM4 9v14c0 .6.4 1 1 1h22c.6 0 1-.4 1-1V9l-9.2 6.2c-1.7 1.2-3.9 1.2-5.6 0L4 9zm2-1l8.3 5.6c1 .7 2.3.7 3.4 0L26 8H6z" />
    </SvgIcon>
);

Envelope.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Envelope;
